export const initLocalStorageWatcher = () => {
  // no-op
};
